import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Center,
  Heading,
  Text,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { satisfiedBenefits } from "../../constants/satisfiedBenefits";
import { useContaxt } from "../../context/Context";
import { HeadLine } from "../HeadLine";
import { Reveal } from "../Reveal";

export function Satisfied() {
  const { color, marginTop, variant } = useContaxt();

  return (
    <Box w={"100%"}>
      <Reveal direction="up" amount={0.2}>
        <HeadLine
          as="h1"
          text={
            <>
              <b>Warum</b> unsere Kunden so <b>zufrieden</b> sind?
            </>
          }
        />
      </Reveal>
      <Center w={"100%"} mt={marginTop}>
        <Wrap justify={"center"} spacing={"25px"}>
          {satisfiedBenefits.map((info, i) => {
            return (
              <WrapItem key={i}>
                <Reveal direction="up" delay={i * 0.1}>
                  <Card
                    bgColor={i === 2 ? color.mainColor : "white"}
                    color={i === 2 && "white"}
                    w={
                      variant === "base" || variant === "sm" ? "90vw" : "16.7vw"
                    }
                    h={"400px"}
                    minW={["300px", "300px", "300px", "300px"]}
                    borderRadius={"25px"}
                    boxShadow="2xl"
                    p="6"
                    rounded="md"
                    _hover={{ bg: "black", color: "white" }}
                  >
                    <CardHeader pt={"10px"}>
                      <Center>{info.icon}</Center>
                    </CardHeader>
                    <CardBody textAlign={"center"}>
                      <Heading as="h3" fontSize={"20px"} fontWeight={"bold"}>
                        {info.title}
                      </Heading>
                      <Box pt={"10px"}>{info.text}</Box>
                    </CardBody>
                  </Card>
                </Reveal>
              </WrapItem>
            );
          })}
        </Wrap>
      </Center>
    </Box>
  );
}
